import { useState, useEffect } from 'react';
import { ServiceImagePlaceholder } from '@/components/shared/ServiceImagePlaceholder';
import { ImageLoader } from '@/components/service-page/image-handling/ImageLoader';
import { ServiceImageSection } from '@/components/service-page/image-handling/ServiceImageSection';
import { supabase } from '@/integrations/supabase/client';

interface ServiceItemImageProps {
  imageUrl?: string | null;
  serviceName: string;
  serviceId: string;
  serviceImages: any[];
  isLoading?: boolean;
}

export const ServiceItemImage = ({ 
  imageUrl, 
  serviceName,
  serviceId,
  serviceImages,
  isLoading = false
}: ServiceItemImageProps) => {
  const [loadedImages, setLoadedImages] = useState<{[key: string]: boolean}>({});
  const [carouselApi, setCarouselApi] = useState<any>(null);
  const [current, setCurrent] = useState(0);

  console.log(`ServiceItemImage for service ${serviceId}:`, {
    imageUrl,
    serviceName,
    serviceImages,
    hasImages: (serviceImages && serviceImages.length > 0 && serviceImages.some(img => img.image_url && img.image_url.trim() !== '')) || 
               (imageUrl && imageUrl.trim() !== ''),
    hasMultipleImages: serviceImages && serviceImages.length > 1
  });

  // Initialize loadedImages state
  useEffect(() => {
    if (serviceImages && serviceImages.length > 0) {
      const initialLoadState: {[key: string]: boolean} = {};
      serviceImages.forEach(img => {
        const imageId = img.id || `${img.image_url}-${serviceImages.indexOf(img)}`;
        initialLoadState[imageId] = false;
      });
      console.log(`Initial load state for service ${serviceId}:`, initialLoadState);
      setLoadedImages(initialLoadState);
    } else if (imageUrl && imageUrl.trim() !== '') {
      setLoadedImages({ [imageUrl]: false });
    }
  }, [serviceImages, imageUrl, serviceId]);

  const handleImageLoad = (imageId: string) => {
    console.log(`Image loaded for service ${serviceId}:`, imageId);
    setLoadedImages(prev => ({
      ...prev,
      [imageId]: true
    }));
  };

  const hasImages = (serviceImages && serviceImages.length > 0 && serviceImages.some(img => img.image_url && img.image_url.trim() !== '')) || 
                   (imageUrl && imageUrl.trim() !== '');
  const hasMultipleImages = serviceImages && serviceImages.length > 1;

  if (!hasImages) {
    return (
      <div className="w-16 h-16 rounded overflow-hidden">
        <ServiceImagePlaceholder 
          serviceName={serviceName} 
          isLoading={isLoading}
        />
      </div>
    );
  }

  return (
    <div className="w-16 h-16 rounded bg-gray-100 flex items-center justify-center overflow-hidden">
      <ServiceImageSection
        serviceImages={serviceImages}
        serviceName={serviceName}
        loadedImages={loadedImages}
        handleImageLoad={handleImageLoad}
        current={current}
        setCarouselApi={setCarouselApi}
        singleImageUrl={imageUrl || undefined}
        hasMultipleImages={hasMultipleImages}
        isLoading={isLoading}
        context="admin"
      />
    </div>
  );
};
